import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";

const selectState = (state: RootState) => state.createLeadModal;

const makeSelectOpen = createDraftSafeSelector(selectState, (state) => state.open);
const makeSelectLoading = createDraftSafeSelector(selectState, (state) => state.loading);

const makeSelectCreatedContractor = createDraftSafeSelector(selectState, (state) => state.createdContractor);

export { selectState, makeSelectOpen, makeSelectLoading, makeSelectCreatedContractor };
